import React from 'react';
import { Skeleton, Card, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { UserStats } from 'services/types/UserStats';
import { ReactComponent as ActivityIcon } from 'assets/svg/activity.svg';
import { ReactComponent as FileTextIcon } from 'assets/svg/file-text.svg';
import { ReactComponent as FlagIcon } from 'assets/svg/flag.svg';
import { ReactComponent as ThumbsUpIcon } from 'assets/svg/thumbs-up.svg';
import styles from '../Profile.module.css';

interface UserStatsSectionProps {
  userStats: UserStats | null;
  isLoading: boolean;
}

const UserStatsSection: React.FC<UserStatsSectionProps> = ({ userStats, isLoading }) => {
  const { t } = useTranslation();

  const getInteractionsCount = () => {
    if (!userStats) return 0;
    return (userStats.like_count || 0) + (userStats.comment_count || 0);
  };

  const statsData = [
    {
      key: 'joined_campaigns',
      label: t('#Profile.joined_campaigns'),
      value: userStats?.enrollment_count || 0,
      icon: <FlagIcon />,
      color: '#10b981',
    },
    {
      key: 'total_submissions',
      label: t('#Profile.total_submissions'),
      value: userStats?.submission_count || 0,
      icon: <FileTextIcon />,
      color: '#f59e0b',
    },
    {
      key: 'total_likes_received',
      label: t('#Profile.total_likes_received'),
      value: userStats?.liked_count || 0,
      icon: <ThumbsUpIcon />,
      color: '#ef4444',
    },
    {
      key: 'interactions',
      label: t('#Profile.interactions'),
      value: getInteractionsCount(),
      icon: <ActivityIcon />,
      color: '#8b5cf6',
    },
  ];

  return (
    <Card className={styles.compactStatsCard} bordered={false}>
      <div className={styles.compactStatsContainer}>
        <Row gutter={[16, 16]} className={styles.compactStatsGrid}>
          {statsData.map((stat) => (
            <Col xs={12} sm={6} key={stat.key}>
              <div className={styles.compactStatItem}>
                <Skeleton loading={isLoading} paragraph={false} active>
                  <div className={styles.compactStatContent}>
                    <div
                      className={styles.compactIconContainer}
                      style={{ background: `linear-gradient(135deg, ${stat.color}, ${stat.color}dd)` }}
                    >
                      {stat.icon}
                    </div>
                    <div className={styles.compactStatInfo}>
                      <div className={styles.compactStatValue}>{stat.value.toLocaleString()}</div>
                      <div className={styles.compactStatLabel}>{stat.label}</div>
                    </div>
                  </div>
                </Skeleton>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </Card>
  );
};

export default UserStatsSection;